import { useEffect } from 'react';

/**
 * Pause the global Lenis smooth-scroll instance while `active` is true.
 * Without this, wheel/touch inside an overlay (Dialog/Sheet/Drawer) still
 * drives the page underneath because Lenis intercepts wheel events on
 * window and scrolls programmatically — body `overflow: hidden` cannot
 * stop it. Restores Lenis on unmount or when `active` becomes false.
 */
export function useLenisLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const lenis = (window as Window & {
      __lenis?: { stop: () => void; start: () => void };
    }).__lenis;
    lenis?.stop();
    return () => {
      lenis?.start();
    };
  }, [active]);
}
